import { TYPE_CONTENT_PACKAGE } from "../../../../constants/page";
import {
    DEFAULT_KEY,
    DESCRIPTION,
    FEATURED_DESCRIPTION,
    FEATURED_KEY,
} from "../../../../pages/FlexibleLandingPage/constants";
import { transformAllContentItems } from "../../../../utils/dataTransform/library";

export const getLayout = (main) => {
    // redefine layout, with a layout that doesn't
    // have the first card as a feature
    switch (main?.layout) {
        case FEATURED_KEY:
            return DEFAULT_KEY;
        case FEATURED_DESCRIPTION:
            return DESCRIPTION;
        default:
            return main?.layout;
    }
};

export const getContentPackage = (contentPackage) => {
    return {
        type: TYPE_CONTENT_PACKAGE,
        key: `content-package-${contentPackage.id}-${contentPackage.updatedAt}`,
        ...transformAllContentItems([contentPackage])[0],
    };
};

export const parseContentPackage = (main) => {
    if (
        main?.content?.[0]?.wrapper?.displayContentPackage && // should display
        main?.content?.[0]?.content?.[0]?.components?.mainContent // is first item a content package
    ) {
        const [pageLineup, ...content] = main.content;
        const [contentPackage, ...pageLineupContent] = pageLineup.content;
        return {
            ...main,
            layout: getLayout(main),
            content: [
                getContentPackage(contentPackage),
                {
                    ...pageLineup,
                    content: pageLineupContent,
                },
                ...content,
            ],
        };
    }
    return main;
};
